import { Highlight } from 'react-instantsearch-hooks-web';
import Button from 'components/helpers/Button';
import { getReportDownloadUrl } from 'lib/util/algolia';
import { HitProps } from './_types';
import { HitHeadline } from './_HitHeading';

export const FeeScheduleHit = ({ hit }: HitProps) => {
  const href = getReportDownloadUrl(hit.objectID);
  return (
    <div>
      <Button linkField={{ value: { href: href } }} variant="link" suppressLinkText="true">
        <HitHeadline hit={hit}>
          <Highlight hit={hit} attribute="title" />
        </HitHeadline>
      </Button>
      {hit?.fileName?.split('.').pop()?.toUpperCase()}
    </div>
  );
};
